import { useOAIQuery } from '~/hooks/reactQuery';

export const useShowcaseGroupQuery = (
  showcaseGroupCode: string,
  enabled = true,
) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/showcase-groups/{showcaseGroupCode}',
    variables: {
      showcaseGroupCode,
    },
    queryOptions: {
      keepPreviousData: true,
      enabled: !!enabled,
    },
  });
};
